<div *ngIf="organizations && organizations.length > 0">
	<h4>{{ (organizations.length > 1 ? 'fs.res.common.organizations.external.assignedExternalOrgUnit_plural' :  'fs.res.common.organizations.external.assignedExternalOrgUnit' ) | hisUi }}</h4>
	<div>
		<p-table [value]="organizations" [paginator]="false">
			<ng-template pTemplate="header">
				<tr>
					<th>{{ 'fs.res.common.organisations.ResearchPartner.business.defaulttext' | hisUi }}</th>
			   		<th>{{ 'fs.res.common.organizations.ResearchPartner.business.address.city' | hisUi}}</th>
				</tr>
			 </ng-template>
			 <ng-template pTemplate="body" let-researchPartner>
				<tr>
					<td>{{researchPartner.defaulttext}}</td>
				    <td>
						<span *ngFor="let postAddress of researchPartner.postAddresses">
							{{postAddress.city}}<br/>
						</span>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>